// extracted by mini-css-extract-plugin
export default {"layoutLine2":"ysmGVggO2QEV6ptU06Vr","placeHolderShimmer":"jpYw2cPNENf1xQCeZd6V"};